import { useEffect } from "react";
import HammondHeroSection from "./components/HeroSection";
import HammondStickyNav from "./components/StickyNav";
import HammondProcessingTimeSection from "./components/ProcessingTimeSection";
import HammondServicesSection from "./components/ServicesSection";
import HammondLocalAreaSection from "./components/LocalAreaSection";
import HammondTestimonialsSection from "./components/TestimonialsSection";
import HammondAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import HammondComparisonSection from "./components/ComparisonSection";
import HammondMistakesSection from "./components/MistakesSection";
import HammondHowItWorksSection from "./components/HowItWorksSection";
import HammondFAQSection, { faqs } from "./components/FAQSection";
import HammondHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import HammondFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";
import HammondTravelTimingSection from "./components/TravelTimingSection";
import HammondDestinationsSection from "./components/DestinationsSection";

export default function HammondPage() {
  useEffect(() => {
    document.title = "Emergency Passport Hammond, LA — Expedited Same-Day Service | Fast Passport Center";

    const setMeta = (name: string, content: string) => {
      let el = document.querySelector(`meta[name="${name}"]`);
      if (!el) { el = document.createElement("meta"); el.setAttribute("name", name); document.head.appendChild(el); }
      el.setAttribute("content", content);
    };
    const setLink = (rel: string, href: string) => {
      let el = document.querySelector(`link[rel="${rel}"]`);
      if (!el) { el = document.createElement("link"); el.setAttribute("rel", rel); document.head.appendChild(el); }
      el.setAttribute("href", href);
    };

    const pageUrl = "https://fastpassportcenter.com/hammond/";
    setLink("canonical", pageUrl);
    setMeta("description", "Emergency and expedited passport services in Hammond, LA — as fast as 24 hours. Serving SLU students, agricultural exporters, and Tangipahoa Parish families. A+ BBB rated, registered State Dept. courier.");
    setMeta("geo.placename", "Hammond, Louisiana");
    setMeta("geo.region", "US-LA");
    setMeta("geo.position", "30.5044;-90.4612");
    setMeta("ICBM", "30.5044, -90.4612");

    const graph = [
      { "@type": "BreadcrumbList", itemListElement: [
        { "@type": "ListItem", position: 1, name: "Home", item: "https://fastpassportcenter.com/" },
        { "@type": "ListItem", position: 2, name: "Louisiana", item: "https://fastpassportcenter.com/louisiana/" },
        { "@type": "ListItem", position: 3, name: "Hammond Passport Services", item: pageUrl },
      ]},
      { "@type": "LocalBusiness", name: "Fast Passport Center", description: "Emergency and expedited passport services for Hammond and Tangipahoa Parish.", url: pageUrl, telephone: "+1-877-253-0084", areaServed: { "@type": "City", name: "Hammond", containedInPlace: { "@type": "State", name: "Louisiana" } }, priceRange: "$$$", openingHours: ["Mo-Fr 09:00-18:00"], aggregateRating: { "@type": "AggregateRating", ratingValue: "4.9", reviewCount: "1200" } },
      { "@type": "FAQPage", mainEntity: faqs.map((faq) => ({ "@type": "Question", name: faq.q, acceptedAnswer: { "@type": "Answer", text: faq.a } })) },
    ];

    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = "structured-data-hammond";
    document.getElementById("structured-data-hammond")?.remove();
    script.textContent = JSON.stringify({ "@context": "https://schema.org", "@graph": graph });
    document.head.appendChild(script);

    return () => {
      document.getElementById("structured-data-hammond")?.remove();
      const canonical = document.querySelector('link[rel="canonical"]');
      if (canonical) canonical.remove();
    };
  }, []);

  return (
    <div className="font-sans">
      <HammondHeroSection />
      <HammondStickyNav />
      <HammondProcessingTimeSection />
      <HammondServicesSection />
      <HammondLocalAreaSection />
      <HammondTravelTimingSection />
      <HammondDestinationsSection />
      <HammondTestimonialsSection />
      <HammondAcceptanceFacilitiesSection />
      <HammondComparisonSection />
      <HammondMistakesSection />
      <HammondHowItWorksSection />
      <HammondFAQSection />
      <HammondHelpfulResourcesSection />
      <SEOCrossLinks currentRoute="/cities/hammond" state="LA" />
      <HammondFinalCTA />
    </div>
  );
}